import * as yup from 'yup';

export const commentValidationSchema = yup.object().shape({
  text: yup.string().required('Required'),
});
